import React from 'react'

const BaseUserContext = React.createContext<Record<string, any>>({})

export const BaseUserProvider = BaseUserContext.Provider;
export default BaseUserContext